export const advice = [
    {
        engine: "Research Phase",
        strength:
            "Your strategic planning skills enable you to allocate resources effectively, ensuring optimal outcomes even under constraints.",
        weakness:
            "Your strategic planning needs improvement. Ineffective resource allocation could lead to suboptimal outcomes and missed opportunities.",
        opportunity:
            "Consider using project management tools and frameworks like Gantt charts or the Eisenhower Matrix to enhance your resource allocation skills.",
        threat: "Continued poor strategic planning may lead to project delays, cost overruns, and missed deadlines.",
    },
    {
        engine: "Marathon Conceptualization",
        strength:
            "Your problem-solving skills allow you to address complex issues efficiently, ensuring that you optimize outcomes within given constraints.",
        weakness:
            "Your problem-solving skills need enhancement. Difficulty in addressing complex issues could lead to inefficiencies and missed opportunities.",
        opportunity:
            "Engage in activities that challenge your problem-solving abilities, such as puzzles, strategic games, or participating in problem-solving workshops.",
        threat: "Failure to enhance problem-solving skills may result in unresolved issues, decreased productivity, and lower team morale.",
    },
    {
        engine: "Sponsorship Campaign",
        strength:
            "Your critical thinking ability enables you to evaluate information effectively, making informed decisions that align with strategic goals.",
        weakness:
            "Your critical thinking skills need development. Difficulty in evaluating information could result in suboptimal decisions.",
        opportunity:
            "Practice critical thinking by analyzing case studies, engaging in debates, and questioning assumptions.",
        threat: "Poor critical thinking skills may result in flawed decision-making and strategic missteps.",
    },
    {
        engine: "Launch the Marathon",
        strength:
            "Your analytical thinking skills allow you to analyze data effectively, making informed decisions based on insights.",
        weakness:
            "Your analytical thinking needs improvement. Difficulty in analyzing data could lead to uninformed decisions and potential risks.",
        opportunity:
            "Take courses in data analysis and statistics, and use data visualization tools to enhance your analytical skills.",
        threat: "Inadequate analytical thinking may result in poor data interpretation and misguided decisions.",
    },
    {
        engine: "Marketing Campaigns",
        strength:
            "Your decision-making skills enable you to make informed choices based on input, ensuring effective and strategic outcomes.",
        weakness:
            "Your decision-making skills need enhancement. Difficulty in making informed choices could result in suboptimal outcomes.",
        opportunity:
            "Use decision-making frameworks like SWOT analysis, decision trees, and cost-benefit analysis to improve your decision-making process.",
        threat: "Poor decision-making skills may lead to ineffective strategies and failed projects.",
    },
    {
        engine: "Event Planner",
        strength:
            "Your risk management skills enable you to evaluate and take risks effectively under time constraints, ensuring balanced outcomes.",
        weakness:
            "Your risk management skills need development. Difficulty in evaluating risks could result in unbalanced decisions and potential setbacks.",
        opportunity:
            "Attend risk management workshops and use risk assessment tools to enhance your ability to evaluate and mitigate risks.",
        threat: "Inadequate risk management may lead to poor risk evaluation and unmitigated issues.",
    },
    {
        engine: "The Marathon Event",
        strength:
            "Your stress management skills enable you to handle pressure effectively, ensuring optimal performance during crises.",
        weakness:
            "Your stress management needs improvement. Difficulty in handling pressure could lead to suboptimal performance and potential errors.",
        opportunity:
            "Practice stress-relief techniques such as mindfulness, regular exercise, and time management to enhance your stress management skills.",
        threat: "Poor stress management may result in burnout, decreased performance, and increased errors.",
    },
];
